import { Instagram, Facebook, Mail, Phone, ArrowUpRight } from "lucide-react";

const EMAIL = "kristyworrell2@gmail.com";
const PHONE_DISPLAY = "+1 (242) 477-3033";
const PHONE_TEL = "+12424773033";

export default function Contact() {
  return (
    <footer
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#1A2B3C] text-[#F4F1EA] pt-24 md:pt-32 pb-12 overflow-hidden"
    >
      {/* Ambient glow */}
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#C05A44]/15 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 -left-40 w-[400px] h-[400px] rounded-full bg-[#4A5D4E]/25 blur-3xl pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="reveal flex items-center gap-3 mb-8">
          <span className="h-px w-8 bg-[#C05A44]" />
          <span className="font-mono-editorial text-[11px] text-[#C05A44]">
            06 · SET THE DATE
          </span>
        </div>

        <h2 className="reveal font-display font-light leading-[0.95] tracking-tighter text-[14vw] md:text-[9vw] lg:text-[8vw]">
          Let’s
          <br />
          <span className="italic">cook.</span>
        </h2>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="reveal md:col-span-6">
            <p className="font-body text-[#F4F1EA]/80 text-lg md:text-xl leading-relaxed max-w-xl">
              Personal chef bookings, small-scale catering, or a single
              unforgettable dinner — send Kristy a note and she'll be in touch
              to plan the menu.
            </p>

            <a
              data-testid="contact-mailto-link"
              href={`mailto:${EMAIL}?subject=Booking%20Inquiry%20—%20Chef%20Kristy%20Worrell`}
              className="mt-10 inline-flex items-center gap-4 group"
            >
              <span className="font-display italic text-2xl md:text-4xl lg:text-5xl text-[#F4F1EA] group-hover:text-[#C05A44] transition-colors break-all">
                {EMAIL}
              </span>
              <ArrowUpRight
                size={28}
                className="text-[#C05A44] transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 shrink-0"
              />
            </a>
          </div>

          <div className="reveal md:col-span-6 md:pl-8 border-t md:border-t-0 md:border-l border-[#F4F1EA]/15 pt-10 md:pt-0 md:pl-12">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
              <div>
                <div className="font-mono-editorial text-[10px] text-[#C05A44] mb-3">
                  BASED IN
                </div>
                <div className="font-display text-2xl md:text-3xl text-[#F4F1EA]">
                  Nassau,
                  <br />
                  <span className="italic">The Bahamas</span>
                </div>
                <div className="font-body text-sm text-[#F4F1EA]/70 mt-4 leading-relaxed">
                  Serving Nassau, Paradise Island, Eleuthera, Harbour Island,
                  Exuma & private charters.
                </div>
              </div>

              <div>
                <div className="font-mono-editorial text-[10px] text-[#C05A44] mb-3">
                  REACH KRISTY
                </div>
                <ul className="space-y-4">
                  <li>
                    <a
                      href={`mailto:${EMAIL}`}
                      className="group flex items-center gap-3 font-body text-base text-[#F4F1EA] hover:text-[#C05A44] transition-colors"
                      data-testid="contact-email-inline"
                    >
                      <Mail size={16} />
                      <span className="nav-link break-all">{EMAIL}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`tel:${PHONE_TEL}`}
                      className="group flex items-center gap-3 font-body text-base text-[#F4F1EA] hover:text-[#C05A44] transition-colors"
                      data-testid="contact-phone-inline"
                    >
                      <Phone size={16} />
                      <span className="nav-link">{PHONE_DISPLAY}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      data-testid="contact-instagram-link"
                      href="https://instagram.com/kristycancook"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group flex items-center gap-3 font-body text-base text-[#F4F1EA] hover:text-[#C05A44] transition-colors"
                    >
                      <Instagram size={16} />
                      <span className="nav-link">@kristycancook</span>
                    </a>
                  </li>
                  <li>
                    <a
                      data-testid="contact-facebook-link"
                      href="https://facebook.com/kristy.worrell"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group flex items-center gap-3 font-body text-base text-[#F4F1EA] hover:text-[#C05A44] transition-colors"
                    >
                      <Facebook size={16} />
                      <span className="nav-link">Kristy Worrell</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          data-testid="footer"
          className="mt-24 pt-8 border-t border-[#F4F1EA]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[#F4F1EA]/60"
        >
          <div className="font-mono-editorial text-[10px]">
            © {new Date().getFullYear()} KRISTY WORRELL · PERSONAL CHEF · THE BAHAMAS
          </div>
          <div className="font-mono-editorial text-[10px]">
            SITE CRAFTED WITH ISLAND TIME
          </div>
        </div>
      </div>
    </footer>
  );
}
